<div class="container">
  <div class="header-container">
    <div class="header-left">
      <img id="logo" src="/assets/images/logo.png" alt="Logo Mile Express" />
    </div>

    <div class="col-md-3">
      <label class="form-label">Data início</label>

      <input
        type="datetime-local"
        class="form-control"
        [(ngModel)]="startDate"
        (change)="onDateChange()"
      />
    </div>

    <div class="col-md-3">
      <label class="form-label">Data fim</label>

      <input
        type="datetime-local"
        class="form-control"
        [(ngModel)]="endDate"
        (change)="onDateChange()"
      />
    </div>

    <div class="col-md-2 d-flex align-items-end">
      <button
        class="btn btn-primary w-100"
        (click)="load(true)"
      >
        Buscar
      </button>
    </div>

  </div>

    <div class="header-center">
      <h1>📦 Painel de Master Air Waybills</h1>
      <p *ngIf="loading_status" id="status">🔄 Carregando...</p>
      <p *ngIf="lastUpdated&&loading_status==false" id="status">Atualizado: {{ lastUpdated | date:'HH:mm:ss' }}</p>
    </div>

    <div class="header-right">
      <button class="btn btn-danger" (click)="logout()">Sair</button>
  </div>
     
</div>
     
<div class="d-flex justify-content-between align-items-center mb-3">
    
  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <div *ngIf="!loading && data.length === 0 && !error" class="text-center text-muted">Nenhum registro encontrado.</div>

  <table *ngIf="!loading && data.length > 0" class="table table-striped table-bordered">
    <thead class="table-dark">
      <tr>
        <th title="Mawb">Código</th>
        <th title="Quantidade. Quantity">Qtt</th>
        <th title="Sua encomenda embarcou para o Brasil. Your order has shipped to Brazil.">DEP</th>
        <th title="Sua encomenda chegou no Brasil. Your order has arrived in Brazil.">ARV</th>
        <th title="Sua encomenda chegou no armazém da Alfândega. Your order has arrived at the Customs warehouse.">BRV</th>
        <th title="Iniciou-se o processo de nacionalização da sua encomenda. The process of customs clearance for your order has started.">CLA</th>
        <th title="Sua encomenda foi nacionalizada. Your order has been cleared through customs.">CLR</th>
        <th title="Encomenda selecionada para inspeção. Order selected for inspection.">HOC</th>
        <th title="O CPF do cliente está em situação irregular. The customer's CPF is in an irregular situation.">IRG</th>
        <th title="Aguardando devolução para a origem. Awaiting return to the origin.">ADE</th>
        <th title="Sua encomenda foi selecionada para inspeção na ANVISA. Your product has been selected for inspection by ANVISA. Please wait.">ANV</th>
        <th title="A remessa foi retida para comprovação de valores. The consignment has been detained for proof of value.">RCV</th>
        <th title="Carga coletada no terminal do courier. Cargo collected at the courier's terminal.">CCC</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of data">
      <td>
        <span
          style="cursor:pointer"
          (click)="downloadExcel(item?.id)"
          [style.opacity]="downloadingMasterIds.includes(item?.id) ? 0.6 : 1"
          [style.pointer-events]="downloadingMasterIds.includes(item?.id) ? 'none' : 'auto'"
        >
          <ng-container *ngIf="!downloadingMasterIds.includes(item?.id)">
            {{ item?.masterCode }}
          </ng-container>

          <ng-container *ngIf="downloadingMasterIds.includes(item?.id)">
            ⏳ Baixando...
          </ng-container>
        </span>

        <span title="Unidade de Despacho e de Embarque. Dispatch and Shipping Unit" 
          [ngClass]="{
            'ua-gru': item?.uaDespacho === 'GRU',
            'ua-vcp': item?.uaDespacho === 'VCP',
            'ua-rec': item?.uaDespacho === 'REC'
              }">{{item?.uaDespacho}}</span>
        </td>
        <td>{{ item?.qtt }}</td>
        <td>{{ item?.dep }}</td>
        <td>{{ item?.arv }}</td>
        <td>{{ item?.brv }}</td>
        <td>{{ item?.cla }}</td>
        <td>{{ item?.clr }}</td>
        <td [ngClass]="{ 'text-yellow': item?.hoc > 0 }">{{ item?.hoc }}</td>
        <td [ngClass]="{ 'text-red': item?.irg > 0 }">{{ item?.irg }}</td>
        <td [ngClass]="{ 'text-red-bold': item?.ade > 0 }">{{ item?.ade }}</td>
        <td [ngClass]="{ 'text-yellow-neon': item?.anv > 0 }">{{ item?.anv }}</td>
        <td [ngClass]="{ 'text-red-bold': item?.rcv > 0 }">{{ item?.rcv }}</td>
        <td [ngClass]="{ 'text-green': item?.qtt == item?.ccc }">{{ item?.ccc }}</td>
      </tr>
    </tbody>
  </table>
</div>
